<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  imageSrc: {
    type: String,
    default: '',
  },
  contactName: {
    type: String,
    default: 'Contact',
  },
});

const emit = defineEmits(['close']);
const { t } = useI18n();

const isOpen = ref(false);

const openModal = () => {
  isOpen.value = true;
};

const closeModal = () => {
  isOpen.value = false;
  emit('close');
};

const downloadImage = () => {
  if (!props.imageSrc) return;

  const link = document.createElement('a');
  link.href = props.imageSrc;
  link.download = `${props.contactName}-avatar.jpg`;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleBackdropClick = event => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

defineExpose({
  openModal,
  closeModal,
});
</script>

// eslint-disable-next-line vue/no-root-v-if
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm"
    @click="handleBackdropClick"
  >
    <div
      class="relative flex flex-col items-center gap-4 max-w-2xl max-h-screen"
    >
      <!-- Close Button -->
      <button
        class="absolute top-4 right-4 z-10 p-2 rounded-full bg-white dark:bg-n-slate-8 hover:bg-n-slate-2 dark:hover:bg-n-slate-7 transition-colors"
        @click="closeModal"
      >
        <span class="i-lucide-x size-5 text-n-slate-12" />
      </button>

      <!-- Image Container -->
      <div
        class="flex items-center justify-center max-w-2xl max-h-[80vh] overflow-auto"
      >
        <img
          :src="imageSrc"
          :alt="contactName"
          class="rounded-lg shadow-lg max-w-full max-h-full object-contain"
        />
      </div>

      <!-- Download Button -->
      <button
        class="flex items-center gap-2 px-4 py-2 rounded-lg bg-white dark:bg-n-slate-8 hover:bg-n-slate-2 dark:hover:bg-n-slate-7 text-n-slate-12 font-medium transition-colors"
        @click="downloadImage"
      >
        <span class="i-lucide-download size-4" />{{
          t('CONTACTS_LAYOUT.DETAILS.DOWNLOAD_IMAGE')
        }}
      </button>
    </div>
  </div>
</template>
